import {Component, Input} from '@angular/core';
import {DynamicFormComponent, DynamicFormControlComponent, FormApiAdapter, IKeyToStyleMap} from 'frontier/browserkit';
import {IControlObject} from 'frontier/nucleus';
import {filter, take, tap} from 'rxjs/operators';
import {NgIf} from '@angular/common';
import AppControlGuids from '../../../../../../api/ControlGuids';
import {MatError} from '@angular/material/form-field';

class InternalNoteApiAdapter extends FormApiAdapter {
  override styles: IKeyToStyleMap = {
    ['InternalNotes;-1']: {
      textAreaInitialRowCount: 14,
    }
  }
}

@Component({
  selector: 'app-internal-note-form',
  templateUrl: '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-control/dynamic-form-control.component.html',
  styleUrl: '../../../../../../../../projects/frontier/browserkit/src/lib/components/control/form-control/dynamic-form/dynamic-form-control/dynamic-form-control.component.scss',
  standalone: true,
  imports: [NgIf, DynamicFormComponent, MatError]
})
export class InternalNoteFormComponent extends DynamicFormControlComponent {
  override GUID: string = AppControlGuids.TInternalNotes;
  override apiAdapter: InternalNoteApiAdapter = new InternalNoteApiAdapter();

  @Input()
  override set selectedElement(element: IControlObject) {
    this.patchFilter({
      parent: element,
      typename: 'cart',
    })

    this.isFormChanging$.pipe(
      filter((v: boolean): boolean => v === false),
      take(1),
      tap(() => this._selectedElement = element)
    ).subscribe()
  };

  override get selectedElement() {
    return this._selectedElement;
  }
}
